// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconUnlock.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconUnlock = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M12.5393 6.51022H12.1077H10.5422L5.17647 6.51378L5.17298 4.32533C5.17298 2.81956 6.37507 1.59467 7.85498 1.59289C8.9403 1.59289 9.87714 2.25167 10.2996 3.19619C10.625 4 12 3.5 11.8283 2.78656C11.2176 1.15824 9.66691 -0.00137588 7.85498 1.22523e-06C5.51194 0.00177887 3.60571 1.94133 3.60746 4.32533L3.61095 6.51378H3.45719C2.65172 6.51556 1.99826 7.18045 2 8V14.5156C2 15.3351 2.65522 16 3.46069 16L12.5428 15.9947C13.3483 15.9947 14.0017 15.3298 14 14.5102V7.99289C14 7.17333 13.3448 6.51022 12.5393 6.51022Z" />
  </BaseIcon>
);

export default IconUnlock;
